export const formatNumberToK = (value: number): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '0';
  }

  if (value < 1000) {
    return value.toString();
  }

  const valueInThousands = value / 1000;
  const roundedToTenth = Math.round(valueInThousands * 10) / 10;
  const formattedCore = Number.isInteger(roundedToTenth)
    ? roundedToTenth.toString()
    : roundedToTenth.toFixed(1);

  const sign = value < 0 ? '-' : '';

  return `${sign}${formattedCore}k`;
};
